import { PhotoCamera } from '@material-ui/icons';
import { colors } from '../theme';
import { Validation } from './CommonData';

export const FormInputsData = [
  {
    groupLabel: 'User Information',
    groupLabelClass: 'fieldset-label',
    key: 'personal',
    groupClass: 'form-fieldset',
    inputs: [
      {
        label: 'User Avatar',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'user_avatar',
        placeholder: '',
        hide: false,
        formControlClass: 'input-form-control file-upload-control',
        type: 'file',
        fieldClass: 'input-file-button',
        id: 'company-avatar-upload',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box file-upload-element',
        icon: PhotoCamera,
        accept: 'image/*',
      },
      {
        label: 'First Name',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'first_name',
        name: 'first_name',
        placeholder: 'First Name',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 3,
        max: 100,
        errors: [{ type: 'required', message: 'Please enter first name' }],
      },
      {
        label: 'Last Name',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'last_name',
        name: 'last_name',
        placeholder: 'Last Name',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        min: 1,
        max: 100,
        errors: [{ type: 'required', message: 'Please enter last name' }],
      },
      {
        label: 'Email',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'email',
        name: 'email',
        placeholder: 'Email',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.email,
        min: 4,
        max: 100,
        errors: [
          { type: 'required', message: 'Please enter your email' },
          { type: 'pattern', message: 'Please enter a valid email' },
        ],
      },
      {
        label: 'Company Name',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'company_name',
        name: 'company_name',
        placeholder: 'Company Name',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'select',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        size: 'small',
        options: [{ label: 'Test company', value: '1' }],
        isRequired: true,
        errors: [{ type: 'required', message: 'Please choose company' }],
      },
      {
        label: 'Designation',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'designation',
        name: 'designation',
        placeholder: 'Designation',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
      },
      {
        label: 'Phone Number',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'phone',
        name: 'phone',
        placeholder: 'Phone Number',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.numberAndPlus,
        min: 4,
        max: 20,
        errors: [
          { type: 'required', message: 'Please enter phone number' },
          { type: 'pattern', message: 'Please enter a valid phone number' },
        ],
      },
      {
        label: 'Extension',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'extension',
        name: 'extension',
        placeholder: 'Extension',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.numberAndPlus,
        min: 1,
        max: 10,
        errors: [
          { type: 'required', message: 'Please enter extension' },
          { type: 'pattern', message: 'Please enter valid extension' },
        ],
      },
      {
        label: 'Password',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'password',
        name: 'password',
        placeholder: 'Password',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'text',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        isRequired: true,
        pattern: Validation.password,
        min: 4,
        max: 50,
        errors: [
          { type: 'required', message: 'Please enter your password' },
          {
            type: 'pattern',
            message:
              'Password must be more than 8 characters including uppercase, lowercase, numbers and special characters',
          },
        ],
      },
    ],
  },
  {
    groupLabel: 'User Roles',
    groupLabelClass: 'fieldset-label',
    key: 'roles',
    groupClass: 'form-fieldset',
    inputs: [
      {
        label: 'User Type',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'user_types',
        name: 'type_id',
        placeholder: 'User Type',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'select',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        size: 'small',
        options: [
          { label: 'Super Admin', value: '1' },
          { label: 'Client', value: '2' },
        ],
        isRequired: true,
        errors: [{ type: 'required', message: 'Please choose user type' }],
      },
      {
        label: 'User Role',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'user_roles',
        name: 'role_id',
        placeholder: 'User Role',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'select',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        size: 'small',
        options: [
          { label: 'Admin', value: '1' },
          { label: 'User', value: '2' },
        ],
        isRequired: true,
        errors: [{ type: 'required', message: 'Please choose user role' }],
      },
    ],
  },
  {
    groupLabel: 'User Permissions',
    groupLabelClass: 'fieldset-label',
    key: 'billing',
    groupClass: 'form-fieldset permission-fieldset',
    inputs: [
      {
        label: 'Dashboard Status',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'dashboard_status',
        name: 'dashboard_status',
        placeholder: 'Dashboard Status',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'toggle',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        labelPlacement: 'start',
        color: `${colors.primary.yellow100}`,
      },
      {
        label: 'Appointments',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'appointments',
        name: 'appointments',
        placeholder: 'Appointments',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'toggle',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        labelPlacement: 'start',
        color: `${colors.primary.yellow100}`,
      },
      {
        label: 'Campaigns',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'campaigns',
        name: 'campaigns',
        placeholder: 'Campaigns',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'toggle',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        labelPlacement: 'start',
      },
      {
        label: 'Bulk Request',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'bulk_request',
        name: 'bulk_request',
        placeholder: 'Bulk Request',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'toggle',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        labelPlacement: 'start',
      },
      {
        label: 'Triggers',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'triggers',
        name: 'triggers',
        placeholder: 'Triggers',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'toggle',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        labelPlacement: 'start',
      },
      {
        label: 'Funnels',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'funnels',
        name: 'funnels',
        placeholder: 'Funnels',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'toggle',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        labelPlacement: 'start',
      },
      {
        label: 'Opportunities',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'opportunities',
        name: 'opportunities',
        placeholder: 'Opportunities',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'toggle',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        labelPlacement: 'start',
      },
      {
        label: 'Conversations',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'conversations',
        name: 'conversations',
        placeholder: 'Conversations',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'toggle',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        labelPlacement: 'start',
      },
      {
        label: 'Contacts',
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4,
        key: 'contacts',
        name: 'contacts',
        placeholder: 'Contacts',
        hide: false,
        formControlClass: 'input-form-control',
        type: 'toggle',
        fieldClass: 'textBoxStyle',
        variant: 'outlined',
        margin: 'dense',
        formElementClass: 'form-input-box',
        labelPlacement: 'start',
      },
    ],
  },
];

// User Type
export const UserTypes = [
  { label: 'Super Admin', name: 'Super Admin', key: 'super_admin', value: 'Super Admin' },
  { label: 'Client', name: 'Client', key: 'client', value: 'Client' },
];

// User Type
export const UserRoles = [
  { label: 'User', name: 'User', key: 'user', value: 'User' },
  { label: 'Admin', name: 'Admin', key: 'admin', value: 'Admin' },
];
